import { ApiClient, ApiErrorMessage, MessageResponsType } from './ApiClient';

export const GetMessageApi = async (): Promise<MessageResponsType> => {
  try {
    const response = await ApiClient.get('/message/item', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const CreateMessageApi = async (body: object) => {
  try {
    await ApiClient.post('/message', body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, message: error?.data };
  }
};

export const UpdateMessageApi = async (id: number, body: object) => {
  try {
    await ApiClient.post('/message/' + id, body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, message: error?.data };
  }
};
